import { Link } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

export function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="mb-6">
          <h1 className="text-6xl font-bold text-slate-300">404</h1>
        </div>
        <h2 className="mb-2 text-2xl font-semibold text-slate-900">
          Página não encontrada
        </h2>
        <p className="mb-6 text-slate-600">
          A página que você está procurando não existe ou foi movida.
        </p>
        <Button asChild variant="default">
          <Link to="/">Voltar ao Início</Link>
        </Button>
      </Card>
    </div>
  )
}
